import styles from './EmployerPortalJobs.module.css';
export const tableHeaderUI = (item, index, tableHeader, selectAll, handleSelectAll, isContent, isHovered, setIsHovered) => {


    return (
        isContent ?
            <>
                {index === 0 ?
                    <div key={index.toString()} className={`${styles.tableHeading} ${styles.halfContainer}`} style={{ flex: 0.2 }}>
                        <input
                            type="checkbox"
                            className={styles.customCheckbox}
                            checked={selectAll}
                            onChange={handleSelectAll}
                        />
                    </div>
                    :
                    index === tableHeader.length - 1 ?
                        <div key={index.toString()} className={`${styles.tableHeading} ${styles.emptyWrapper}`}></div>
                        :
                        <div key={index.toString()} className={`${styles.tableHeading} ${styles.contentWrapper}`}>{item}</div>}
            </>

            :
            index === 0 ?
                    <div key={index.toString()} className={`${styles.tableHeading} ${styles.halfContainer}`} style={{ flex: 0.2 }}>
                    <input
                        type="checkbox"
                        className={styles.customCheckbox}
                        checked={selectAll}
                        onChange={handleSelectAll}
                    />
                </div>
                :
                index === tableHeader.length - 1 ?
                    <div key={index.toString()} className={`${styles.tableHeading} ${styles.emptyWrapper}`}></div>
                    :
                    <div key={index.toString()} className={`${styles.tableHeading} ${styles.contentWrapper}`}>{item}</div>

    );
}